module.exports = "/_next/static/images/Dish-Programming-5a3888145f1b2a3815f035be744104c7.png";